module.exports = __webpack_public_path__ + "static/img/06.e0b97401.jpg";